import { Link, Outlet } from 'react-router-dom'

export default function AdminLayout() {
  return (
    <div>
      <div className="venue-band" style={{ padding: '16px clamp(16px, 4vw, 40px)' }}>
        <div className="venue-top">
          <div className="wordmark">
            <span className="flag">🛠️</span>
            <b>NHCA Live</b>
            <small>Event Admin</small>
          </div>
          <Link to="/" style={{ color: '#fff', fontSize: '0.82rem', textDecoration: 'underline' }}>
            ← Back to live board
          </Link>
        </div>
      </div>
      <main>
        <Outlet />
      </main>
    </div>
  )
}
